module.exports = __webpack_public_path__ + "static/media/KITE-BNB.4b9e8286.png";